import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <footer className="bg-[#2e4e18] text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {/* Brand Section */}
          <div>
            <Link to="/shop" onClick={scrollToTop} className="inline-block mb-6">
              <img
                src="/logo.svg"
                alt="Book my fresh"
                className="h-16 w-auto rounded-lg brightness-125 contrast-110"
              />
            </Link>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#548B2E] flex-shrink-0" />
                <a href="mailto:info@bookmyfresh.com" className="text-gray-300 hover:text-[#548B2E] transition-colors">
                  info@bookmyfresh.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#548B2E] flex-shrink-0" />
                <a href="tel:+918078622096" className="text-gray-300 hover:text-[#548B2E] transition-colors">
                  +91-8078622096
                </a>
              </div>
            </div>
            <div className="flex space-x-3 mt-6">
              <a href="https://www.linkedin.com/company/book-my-fresh?trk=blended-typeahead" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#3f6b20] hover:bg-[#548B2E] flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/p/BOOK-MY-FRESH-61556521047540/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#3f6b20] hover:bg-[#548B2E] flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/bookmyfresh?igsh=MTRrODY1Nml0Z2J6YQ==" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#3f6b20] hover:bg-[#548B2E] flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Service Column 1 */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Service</h3>
            <ul className="space-y-3">
              <li><Link to="/home" onClick={scrollToTop} className="text-gray-300 hover:text-[#548B2E] transition-colors">Home</Link></li>
              <li><Link to="/home#about" className="text-gray-300 hover:text-[#548B2E] transition-colors">About Us</Link></li>
            </ul>
          </div>

          {/* Service Column 2 */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/contact" onClick={scrollToTop} className="text-gray-300 hover:text-[#548B2E] transition-colors">Contact</Link></li>
              <li><Link to="/faq" onClick={scrollToTop} className="text-gray-300 hover:text-[#548B2E] transition-colors">FAQ</Link></li>
              <li><Link to="/legal" onClick={scrollToTop} className="text-gray-300 hover:text-[#548B2E] transition-colors">Legal</Link></li>
            </ul>
          </div>

        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8">
          <p className="text-center text-gray-400">© Copyright 2026 by Book my fresh | All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
